/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_Preview_Url_RejectedInputs */

const vi_einvoice_error_preview_url_rejected = /** @type {(inputs: Einvoice_Error_Preview_Url_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA trả về đường dẫn tải bản xem trước không được hỗ trợ. Vui lòng thử lại sau.`)
};

/**

* @param {Einvoice_Error_Preview_Url_RejectedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_preview_url_rejected = /** @type {((inputs?: Einvoice_Error_Preview_Url_RejectedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_Preview_Url_RejectedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_preview_url_rejected(inputs)
});